﻿import { createFileRoute } from "@tanstack/solid-router";
import { seo } from "~/utils/seo";

export const Route = createFileRoute("/_main/data-deletion")({
  head: () => ({
    meta: seo({
      title: "Data Deletion Request | ileckie.com",
      description:
        "Request deletion of your personal data from ileckie.com services.",
      path: "/data-deletion",
    }),
  }),
  component: DataDeletionPage,
});

function DataDeletionPage() {
  return (
    <main class="flex min-h-screen flex-col bg-[#050308] selection:bg-indigo-500/30 selection:text-white">
      <div class="mx-auto w-full max-w-4xl px-6 py-12 md:py-16 lg:py-20">
        <h1 class="mb-2 text-4xl font-bold text-white">
          Data Deletion Request
        </h1>
        <p class="mb-8 text-sm text-white/60">Last updated: Jan 1, 2026</p>

        <p class="mb-6 leading-relaxed text-white/60">
          We respect your right to privacy and control over your personal data.
          If you would like to request the deletion of your personal information
          from our systems, we're here to help.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold">
          How to Request Data Deletion
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          To submit a data deletion request, please contact us via our{" "}
          <a href="/contact" class="text-indigo-400 hover:underline">
            contact page
          </a>
          . In your message, please include:
        </p>
        <ul class="mb-8 ml-6 list-disc space-y-3 text-white/60">
          <li>
            Your full name and email address associated with your account or
            services
          </li>
          <li>A clear statement that you wish to delete your personal data</li>
          <li>Any specific services or products you've used with us</li>
          <li>
            Any additional information that can help us identify your data in
            our systems
          </li>
        </ul>

        <h2 class="mb-4 mt-8 text-2xl font-semibold">What Happens Next</h2>
        <p class="mb-6 leading-relaxed text-white/60">
          Once we receive your data deletion request:
        </p>
        <ol class="mb-8 ml-6 list-decimal space-y-3 text-white/60">
          <li>
            We will verify your identity to ensure the security of your data
          </li>
          <li>We will process your request within 30 days of verification</li>
          <li>
            You will receive a confirmation email once your data has been
            deleted
          </li>
        </ol>

        <h2 class="mb-4 mt-8 text-2xl font-semibold">Important Information</h2>
        <p class="mb-6 leading-relaxed text-white/60">
          Please note that certain data may need to be retained for legal,
          security, or legitimate business purposes as outlined in our{" "}
          <a href="/privacy" class="text-indigo-400 hover:underline">
            Privacy Policy
          </a>
          . This may include:
        </p>
        <ul class="mb-8 ml-6 list-disc space-y-3 text-white/60">
          <li>
            Transaction records required for financial or legal compliance
          </li>
          <li>Data necessary to resolve disputes or enforce our agreements</li>
          <li>Information required by applicable laws and regulations</li>
        </ul>
        <p class="mb-6 leading-relaxed text-white/60">
          After deletion, your data will be permanently removed from our active
          systems and cannot be recovered.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold">Questions?</h2>
        <p class="leading-relaxed text-white/60">
          If you have any questions about our data deletion process or your
          privacy rights, please don't hesitate to{" "}
          <a href="/contact" class="text-indigo-400 hover:underline">
            contact us
          </a>
          .
        </p>
      </div>
    </main>
  );
}
